import { render, staticRenderFns } from "./participant-classical.vue?vue&type=template&id=2006984b"
import script from "./participant-classical.vue?vue&type=script&lang=js"
export * from "./participant-classical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports